export default {
  components: {
  },
  props: ['item', 'index', 'transferType', 'projectSubType'],
  data() {
    return {
    };
  },
  created() {
  },
  computed: {
  },
  methods: {
  }
};
